import React from 'react';
import './AppVersion.scss';

const AppVersion = (): JSX.Element => (
    <span className="app-version text-muted">{`ver. ${process.env.REACT_APP_BUILD_VERSION}`}</span>
);

export default AppVersion;
